import { render, staticRenderFns } from "./company-baseinfo-form.vue?vue&type=template&id=41c8cc2c"
import script from "./company-baseinfo-form.vue?vue&type=script&lang=js"
export * from "./company-baseinfo-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports